<template>
  <div class="myRegistrationForm">
    <el-main>
      <UserCenterTop />
      <el-row class="nofull event_content">
        <UserMenu :myMenuActiveId="myMenuActiveId" />
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>学者中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{ eventTitle }}</el-breadcrumb-item>
            <el-breadcrumb-item>我的报名表</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="row_header myEventDescPart">
            <MyEventDesc @eventTitle="et" />
          </div>
          <MyEventMenu :myEventMenuActiveIndex="myEventMenuActiveIndex" />
          <!--报名表表单-->
          <div
            style="position: relative; min-height: 400px"
            v-if="this.registration_status !== 1"
          >
            <div class="contentEmpty">
              <div style="margin-bottom: 10px">还没有报名</div>
              <el-button
                style="padding-left: 40px; padding-right: 40px"
                type="success"
                @click="gotoEventDetail"
                >去 报 名</el-button
              >
            </div>
          </div>
          <div v-else>
            <RegistrationFormContent ref="child" />
          </div>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu.vue';
import UserCenterTop from '@/components/UserCenterTop.vue';
import MyEventMenu from '@/components/MyEventMenu';
import MyEventDesc from '@/components/MyEventDesc';
import RegistrationFormContent from '@/components/RegistrationFormContent';

export default {
  name: 'MyRegistrationForm',
  components: {
    UserMenu,
    UserCenterTop,
    MyEventMenu,
    MyEventDesc,
    RegistrationFormContent,
  },
  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');
  },
  data() {
    return {
      myMenuActiveId: '1',
      myEventMenuActiveIndex: '1',
      eventTitle: '',
      signUpState: null,
    };
  },
  methods: {
    gotoEventDetail() {
      let forum_id = this.$route.query.eventId;
      this.$router.push({ path: '/eventDetail', query: { eventId: forum_id } });
    },
    et(data) {
      this.eventTitle = data;
    },
  },
  computed: {
    registration_status: {
      get() {
        return this.$store.state.toGetCurrentRegistration.registration_status;
      },
    },
  },
};
</script>

<style scoped></style>
